const steps = [
  { number: "01", icon: "ri-discuss-line", title: "Understand Your Needs", description: "We start by listening. Our team takes time to understand your budget, location preference, lifestyle needs, and long-term goals before recommending anything." },
  { number: "02", icon: "ri-search-eye-line", title: "Recommend the Right Property", description: "Based on your requirements, we shortlist the most suitable projects or plots from our portfolio — with honest insights on value, location, and potential." },
  { number: "03", icon: "ri-tools-line", title: "Plan and Execute with Clarity", description: "Once you decide, we handle all planning, documentation, and execution with full transparency — keeping you informed at every milestone." },
  { number: "04", icon: "ri-shake-hands-line", title: "Support Until You're Settled", description: "Our relationship doesn't end at sale. We support you through site visits, registration, and beyond — ensuring a smooth and confident experience." },
];

export default function HowWeWork() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#EAF5E1] text-[#7FBF3F] text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider">
            <i className="ri-route-line"></i>Our Process
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#212121] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            How We Work
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
            A simple, transparent process designed to make your property journey smooth and stress-free from start to finish.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 relative">
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-[#EAF5E1] z-0"></div>

          {steps.map((step, idx) => (
            <div key={step.number} className="relative z-10 flex flex-col items-center text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-[#1B2A4A] rounded-full mb-5 relative">
                <i className={`${step.icon} text-2xl text-white`}></i>
                <span className="absolute -top-1 -right-1 w-6 h-6 flex items-center justify-center bg-[#7FBF3F] text-white text-xs font-bold rounded-full">
                  {idx + 1}
                </span>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#212121] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a href="/services#enquire" className="inline-flex items-center gap-2 border-2 border-[#7FBF3F] text-[#7FBF3F] hover:bg-[#7FBF3F] hover:text-white text-sm font-semibold px-7 py-3 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap">
            <i className="ri-calendar-check-line"></i>Start Your Journey Today
          </a>
        </div>
      </div>
    </section>
  );
}
